import React, { Fragment } from 'react'
import { Stepper } from '../../components/Stepper/Stepper'
import { AsnSearch } from './stepper/AsnSearch'

export const StepperContainer: React.FC = () => {
  return (
    <Stepper>
      {(controls) => (
        <Fragment>
          <AsnSearch controls={controls} />
        </Fragment>
      )}
    </Stepper>
  )
}
